module.exports = __webpack_public_path__ + "static/squarespace.6696bf47.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/logos/squarespace.png
// module id = 878
// module chunks = 213534597649335